import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, ProgressIndicator, ErrorBanner, ReduxControls } from 'rhombus-react';
import { initialize, reduxForm, reset, Field } from "redux-form";

import { DUPLICATE_IMPOSIUM_PROJECT_FORM } from "widgets/forms/list";
import BasicModal from "widgets/modals/BasicModal";
import { closeModal } from "reducers/Modal";
import { duplicateImposiumProject, clearImposiumErrors } from "reducers/ImposiumProjects";

import { requiredNotNull } from "widgets/forms/validators/validators";


import "./DuplicateImposiumProjectModal.css";


export function DuplicateImposiumProjectModal(props){
	const dispatch = useDispatch();
	const { handleSubmit, invalid, projectId } = props;

	const {
		libraryId,
		isSaving,
		errorObj,
	} = useSelector((state) => {
		return {
			libraryId: state.libraryProperties.id,
			isSaving: state.imposiumProjects.isSaving,
			errorObj: state.imposiumProjects.error || {},
		};
	});
	function onClose(){
		dispatch(reset(DUPLICATE_IMPOSIUM_PROJECT_FORM));
		dispatch(closeModal());
	}

	const submitDuplicateProject = (handleSubmit((values) => {
		const { newProjectName } = values;

		dispatch(duplicateImposiumProject(libraryId, projectId, newProjectName)).then((resp) => {
			if (resp.success) {
				// Close modal - asset list will be updated via WebSocket when duplication completes
				onClose();
			}
		});
	}));


	useEffect(() => {
		dispatch(clearImposiumErrors());
		dispatch(initialize(DUPLICATE_IMPOSIUM_PROJECT_FORM, {
			newProjectName: `${props.projectName} copy`,
		}));
	}, []);

	function renderContent(){
		return (
			<form id={DUPLICATE_IMPOSIUM_PROJECT_FORM} onSubmit={submitDuplicateProject}>
				<ProgressIndicator key="loading" isLoading={isSaving} />
				{ !!Object.keys(errorObj)?.length && <ErrorBanner
					title="Sorry, please fix the errors below and try again."
					messages={[errorObj.description || errorObj.name || 'Something went wrong']} />
				}
				<Field
					name="newProjectName"
					className="project-name"
					label="Name for Duplicated Imposium Project"
					required
					validate={[requiredNotNull]}
					component={ReduxControls.Input}
				/>
			</form>
		);
	}

	function renderFooter(){
		return ([
			<Button disabled={isSaving} key="back" theme="default" onClick={onClose}>Cancel</Button>,
			<Button
				key="create"
				disabled={isSaving || invalid}
				type="submit"
				theme="green"
				form={DUPLICATE_IMPOSIUM_PROJECT_FORM}>
				Create
			</Button>
		]);
	}

	const modalProps = {
		title: `Duplicate Imposium Project - ${props.projectName}`,
		className: "duplicate-imposium-project-modal",
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

DuplicateImposiumProjectModal.displayName = "DuplicateImposiumProjectModal";


export default reduxForm({
	form: DUPLICATE_IMPOSIUM_PROJECT_FORM,
})(DuplicateImposiumProjectModal);
